import { mapMutations, mapActions } from "vuex";
import formFieldMixin from "./form-field";
import { formRecaptchaMixin } from "./form-recaptcha";
import Vue from "vue";

export default {
  mixins: [
    formFieldMixin,
    formRecaptchaMixin
  ],
  data: () => ({
    isValid: false,
    infoForm: {
        // action: 'feedback/send',
        disabledForm: false,
        isPersonalData: false,
        errorPersonalData: false,
        addCheck: {
            // дополнительная галочка (например в форме отзыва)
            visible: false,
            is: 0,
            error: false,
        },
    },
    pattern: '\+7\(111)111-11-11',
    visibleDatePicker: -1,
    cmpForm: [],
    dropzoneOptions: {
        url: 'callbackBecomeVendor',
        autoQueue: false,
        thumbnailWidth: 80,
        thumbnailHeight: 80,
        maxFiles: 12, // максимальное количество файлов
        maxFilesize: 10, // максимальный вес одного файла, MB
        addRemoveLinks: true,
        dictRemoveFile: '×',
        acceptedFiles: '.jpg,.jpeg,.png,.docx,.doc,.pdf,.txt,.tif,.svg',
        dictFileTooBig: 'Файл слишком большой. Максимальный размер файла: {{maxFilesize}} MB.',
        dictInvalidFileType: 'Вы не можете загружать файлы этого типа.',
        dictMaxFilesExceeded: 'Вы не можете больше загружать файлы.',
    },
  }),
  methods: {
    ...mapActions('modal', ['modalClose']),
    ...mapMutations('questionnaries', ['setUsername', 'setCompanyName']),
    clearFrom () {
      this.$parent.infoForm.success = false;
      this.$parent.infoForm.error = false;
      for (const field of this.cmpForm) {
        field.error = false;
        field.valid = false;

        if (field.type === 'select') {
          field.value = [];
          if (field.typeField === 8 && this.$refs.selectCustom.length) {
              this.$refs.selectCustom.forEach(item => {
                  item.clearSelect();
              });
          }
          continue;
        }

        if (field.type === 'checkbox') {
          field.list.forEach(item => item.checked = false);
          continue;
        }

        field.value = '';
      }

      if (this.$refs.dropzone) {
        this.$refs.dropzone[0].removeAllFiles(true);
      }

      this.infoForm.isPersonalData = false;
      this.infoForm.errorPersonalData = false;

      document.querySelector('#personal-data-feedback' + this.formInfo.id).checked = false;
    },
    validate () {
      let is_valid = true;

      for (const field of this.cmpForm) {
        const result = this.validateField(field)
        
        if (result.valid) continue;

        this.isValid = false;
      }

      // проверка галочки
      if (
        (!this.$route.fullPath.includes('/lk') || this.personalData || this.lkPersonalData) &&
        !this.infoForm.isPersonalData
      ) {
        this.infoForm.errorPersonalData = true;
        is_valid = false;
      }

      this.isValid = is_valid;
    },
    submitForm() {
      this.validate();

      if (!this.isValid) {
        this.$root.scrollToBlock('._error')
        return;
      }

      if (process.env.NODE_ENV === 'development') {
        this.sendForm();
        return;
      }
      
      this.executeRecaptcha();
    },
    async sendForm () {
      this.infoForm.disabledForm = true;
      const fd = new FormData();

      fd.append('recaptchaToken', this.recaptchaToken);
      if (this.formInfo.placeId) fd.append('placeId', this.formInfo.placeId);
      if (this.formInfo.id) fd.append('id', this.formInfo.id);
      if (this.formInfo.nameEntity) fd.append('nameEntity', this.formInfo.nameEntity);
      if (this.formInfo.entityId) fd.append('entityId', this.formInfo.entityId);
      // для лк, форма оставить отзыв
      if (this.leadId) fd.append('leadId', this.leadId);
      
      for (const field of this.cmpForm) {
        this.appendField(field, fd)
      }

      try {
        const res = await Vue.http.post(this.action, fd)
        const data = await res.json();

        if (!data.success) throw data;

        if (this.isReload) {
          this.$router.go(0);
          return;
        }

        this.$parent.infoForm.success = true;
        if (!this.$parent.freezeForm) setTimeout(this.clearFrom, 5000);

        if (this.$route.name !== 'lk-requests') return

        this.$router.push({
          name: this.$route.name,
          query: Object.assign({}, this.$route.query, { update: 'true' })
        });
      } catch (data) {
        this.openError(data);
      } finally {
        this.infoForm.disabledForm = false;
      }
    },
    openError (data) {
      if (this.checkError) {
        for (let i = 0; i < Object.keys(data.errors).length; i++) {
          let key = Object.keys(data.errors)[i];
          let item = this.cmpForm.find(el => el.id === key);
          if (item) {
            item.textError = data.errors[key][0];
            item.valid = false;
            item.error = true;
          } else {
            this.cmpForm.forEach(el => {
              el.textError = '';
            });
          }
        }
        return;
      }
      if (data.errors) {
        let key = Object.keys(data.errors)[0];
        if (data.errors[key][0]) {
          this.$parent.errorTextForm = data.errors[key][0];
        }
      } else {
        this.$parent.errorTextForm = null;
      }
      this.$parent.infoForm.error = true;

      setTimeout(() => {
        this.$parent.infoForm.error = false;
      }, 5000);
    },
  },
  created () {
    if (this.region.mask) {
      this.pattern = this.region.mask;
    }

    let form = JSON.parse(JSON.stringify(this.formInfo));
    form.fields.forEach(item => {
      if (!item.content.value) {
        item.content.value = item.content.defaultValue ? item.content.defaultValue : '';
      }
      item.content.error = false;
      item.content.valid = false;
      item.content.textError = '';

      this.setupField(item.content)
    });
    // Object.assign нужен для реактивности
    this.cmpForm = form.fields.map(item => Object.assign({}, item.content));

    this.infoForm.addCheck.visible = this.check;
  }
}


// WEBPACK FOOTER //
// ./src/templates/components/mixins/form-dynamic.js